import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef, ElementType, ReactElement, ReactNode } from "react";

type HeadingLevel = 1 | 2 | 3 | 4;
type HeadingSize = "hero" | "section" | "page" | "subsection" | "metric" | "title";

const headingSizes: Record<HeadingSize, string> = {
  hero: "text-3xl font-bold leading-tight text-balance text-gray-900 md:text-4xl lg:text-5xl",
  section: "text-2xl font-bold leading-tight text-balance text-gray-900 sm:text-3xl lg:text-4xl",
  page: "text-2xl font-medium leading-snug text-gray-900",
  subsection: "text-lg font-semibold leading-snug text-balance text-gray-900 sm:text-xl",
  metric: "text-3xl font-bold leading-tight text-gray-900",
  title: "text-sm font-bold leading-6 text-gray-600",
};

interface HeadingProps extends Omit<ComponentPropsWithoutRef<"h1">, "children"> {
  children: ReactNode;
  level?: HeadingLevel;
  size?: HeadingSize;
}

export function Heading({ children, className, level = 2, size = "section", ...props }: HeadingProps): ReactElement {
  const Component = `h${level}` as ElementType;

  return (
    <Component className={cn(headingSizes[size], className)} {...props}>
      {children}
    </Component>
  );
}
